import { render, staticRenderFns } from "./xnfz.vue?vue&type=template&id=f1bbe7b2&"
import script from "./xnfz.vue?vue&type=script&lang=js&"
export * from "./xnfz.vue?vue&type=script&lang=js&"
import style0 from "./xnfz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports